import * as actionTypes from "../actions/actionTypes";
import authgetUser from "../../services/auth.getUser";
import { updateObject } from "../../shared/utility";

const tokenExists = authgetUser();

const initialState = {
  isAuth: tokenExists.accessToken ?true :false,
  municipalityId: "",
  isReloaded: false,
  UsernameDesc: "",
  isTemporary: false,
};

const authValid = (state, action) => {
  return updateObject(state, { isAuth: action.payload.isAuth });
};

const setMunicipality = (state, action) => {
  return updateObject(state, { municipalityId: action.payload.municipalityId });
};

const setUsername = (state, action) => {
  return updateObject(state, { UsernameDesc: action.payload.UsernameDesc });
};

const setTemporaryPassword = (state, action) => {
  return updateObject(state, { isTemporary: action.payload.isTemporary });
};

const setIsReloaded = (state, action) => {
  return updateObject(state, { isReloaded: action.payload.isReloaded });
};

const AuthReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.AUTHORIZE_VALIDATION:
      return authValid(state, action);
    case actionTypes.SET_MUNICIPALITY_ID:
      return setMunicipality(state, action);
    case actionTypes.SET_USERNAME_DESC:
      return setUsername(state, action);
    case actionTypes.SET_ISRELOADED:
      return setIsReloaded(state, action);
    case actionTypes.SET_ISTEMPORARY:
      return setTemporaryPassword(state, action);

    default:
      return state;
  }
};

export default AuthReducer;
